export type CheckoutFaqItem = {
  id: string;
  title: string;
  paragraphs: string[];
};

/**
 * @description FAQ copy for the checkout page experiment layout, in display order.
 */
export const CHECKOUT_FAQ_ITEMS: CheckoutFaqItem[] = [
  {
    id: 'add-later',
    title: 'Can I add coverage later?',
    paragraphs: [
      "Yes, but the rate is based on appliance age at signup — so today's price is the best it'll be. If you don't take up coverage today, we'll contact you during the warranty period with a new rate.",
    ],
  },
  {
    id: 'pay-annually',
    title: 'Can I pay annually instead of monthly?',
    paragraphs: [
      'No, we only offer the option to pay monthly. This gives you the flexibility to keep your coverage for as long as you like.',
    ],
  },
  {
    id: 'cancel-anytime',
    title: 'Can I really cancel anytime, with no catch?',
    paragraphs: [
      "Yes — it's a rolling monthly contract with no cancellation fee, ever. Cancel anytime.",
    ],
  },
  {
    id: 'multiple-appliances',
    title: 'Can I protect more than one appliance?',
    paragraphs: [
      "Yes, you can protect multiple appliances. You'll just need to register them one at a time. Once you've completed the first registration, you'll have the option to add and protect another appliance.",
    ],
  },
  {
    id: 'register-only',
    title: 'How do I register my appliance without buying additional coverage?',
    paragraphs: [
      'If you don’t want a protection plan, go back a step and select ‘Register only’ when you’re shown a quote.',
    ],
  },
];
